// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { DefaultPalette as palette } from '@fluentui/react';
/**
 * @private
 */
export const getVideoTileOverrideColor = (isVideoRendered, theme, color) => {
    // when video is being rendered, the info has a grey-ish background, so no use of theme
    return { color: isVideoRendered ? palette[color] : theme.palette[color] };
};
//# sourceMappingURL=videoTileStylesUtils.js.map